import { useChartStore } from '@/stores/chartStore';
import { INVALID_CHART_RECID } from '@/composables/isValidChartRecid';
import { ChartStore } from '@/types/ChartStore';

export function clearRecidsOfChartAndLoadSymbolOnlyChartBeingViewed(chartRecid: number) {
  const chartStore = useChartStore();

  const patchObject: Partial<ChartStore> = {};

  if (chartRecid === chartStore.recidOfChartBeingViewed) {
    patchObject.recidOfChartBeingViewed = INVALID_CHART_RECID;
  }

  if (chartRecid === chartStore.recidOfLoadSymbolOnlyChartBeingViewed) {
    patchObject.recidOfLoadSymbolOnlyChartBeingViewed = INVALID_CHART_RECID;
  }

  if (Object.keys(patchObject).length) {
    chartStore.$patch(patchObject);
  }
}
